<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg4 md4>          
            <v-card pa-0>              
              <v-divider></v-divider>
                <v-card-text class="">
                  <v-form v-model="valid">
                    <v-autocomplete
                        v-bind:items="kotas"
                        v-bind:filter="customFilter"     
                        v-bind:search-input.sync="kotaSearch"
                        item-text="name"
                        item-value="id"
                        v-model="formModel.kota_id"
                        label="Kota"
                        hide-no-data 
                        :loading="kotaLoading"
                    ></v-autocomplete>  
                    
                    <v-autocomplete
                        v-bind:items="kecamatans"
                        v-bind:filter="customFilter"     
                        v-bind:search-input.sync="kecamatanSearch"
                        item-text="name"
                        item-value="id"
                        v-model="formModel.kecamatan_id"
                        label="Kecamatan"
                        hide-no-data 
                        :loading="kecamatanLoading"
                    ></v-autocomplete>  
                    
                    <v-autocomplete
                        v-bind:items="kelurahans"
                        v-bind:filter="customFilter"     
                        v-bind:search-input.sync="kelurahanSearch"
                        item-text="name"
                        item-value="id"
                        v-model="formModel.kelurahan_id"
                        label="Kelurahan"
                        hide-no-data 
                        :loading="kelurahanLoading"
                    ></v-autocomplete>      

                    <v-text-field
                        label="Nama"
                        placeholder="exp: TPS 14 [NAMA KELURAHAN]"
                        name="name"                              
                        v-model="formModel.name"
                        v-validate="'required'"
                        data-vv-name="name"     
                        :error-messages="errors.collect('name')"  
                        required
                    ></v-text-field>

                    <v-text-field
                        type="number"
                        label="Nomor TPS"
                        name="no"                              
                        v-model="formModel.no"
                        v-validate="'required'"
                        data-vv-name="no"     
                        :error-messages="errors.collect('no')"  
                        required
                    ></v-text-field>
                    
                    <v-layout>
                      <v-flex md6 xs6>
                        <v-text-field                          
                          label="PT LAKI-LAKI"                                                        
                          type="number"
                          v-model="formModel.pt_l"
                          v-validate="'required'"
                          data-vv-name="pt_l"     
                          :error-messages="errors.collect('pt_l')"  
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6 xs6>
                        <v-text-field                          
                          label="PT PEREMPUAN"                                                        
                          type="number"
                          v-model="formModel.pt_p"
                          v-validate="'required'"
                          data-vv-name="pt_p"     
                          :error-messages="errors.collect('pt_p')"  
                          required
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    
                    <v-textarea
                        label="Alamat"
                        name="alamat"                              
                        v-model="formModel.alamat"
                        v-validate="'required'"
                        data-vv-name="alamat"     
                        :error-messages="errors.collect('alamat')"  
                        required
                    ></v-textarea>
                                
                            
                      <div class="form-btn">
                          <v-btn v-if="!isUpdate" @click="save(isUpdate)" color="success">Create</v-btn>
                          <v-btn v-else @click="save(isUpdate)" color="primary">Update</v-btn>                                                                                              
                      </div>  
                        
                  </v-form>  
              </v-card-text>       
            </v-card>
          </v-flex>                   
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Tps  from '@/apps/frc/models/Tps';    
import moment from 'moment';

var model = new Tps();

export default {
    $_veeValidate: {
        validator: 'new'
    },    
    data: () => ({
        isEditing:true,
        isUpdate:false,        
        name:null,
        
        kelurahans:[],
        kelurahanSearch:null,
        kelurahanLoading : false,
        
        kecamatans:[],
        kecamatanSearch:null,
        kecamatanLoading : false,
        
        
        kotas:[],
        kotaSearch:null,
        kotaLoading : false,
        
        formModel: {
          kota_id : null,
          kecamatan_id : null,
          kelurahan_id : null,
          no : null,
          name : null,
          alamat : null,
          tp_l : null,
          tp_t : null,
        },
        //countries: Countries,
        balance: [],    
        valid: true
    }),
    watch:{
        formModel : {
          handler(newVal, oldVal){
             
          },
          deep:true,
        },
        
        kelurahanSearch(newVal){
          setTimeout(()=>{
            if(newVal === this.kelurahanSearch){
              this.kelurahanLoading = true;
              model.kelurahans({'KelurahanSearch[name]':newVal,'KelurahanSearch[kecamatan_id]':this.formModel.kecamatan_id}).then(data=>{
                this.kelurahans = data;  
                this.kelurahanLoading = false;
              }); 
            }
          }, 500);          
        },
        
        kecamatanSearch(newVal){
          setTimeout(()=>{
            if(newVal === this.kecamatanSearch){
              this.kecamatanLoading = true;
              model.kecamatans({'KecamatanSearch[name]':newVal,'KecamatanSearch[kota_id]':this.formModel.kota_id}).then(data=>{
                this.kecamatans = data;  
                this.kecamatanLoading = false;
              }); 
            }
          }, 500);                    
        },
        
        kotaSearch(newVal){
          setTimeout(()=>{
            if(newVal === this.kotaSearch){
              this.kotaLoading = true;
              model.kotas({'KotaSearch[name]':newVal}).then(data=>{
                this.kotas = data;  
                this.kotaLoading = false;
              }); 
            }
          }, 500);          
        },
    },
    created () {
      
    },    
    mounted () {this.init();}, 
    methods : {
        init(){
            if(this.$route.query.id){
                this.isUpdate  = true;
                model.one({id : this.$route.query.id }).then(data => {                      
                    Object.assign(this.formModel, data === null ? {}:data);                                  
                    this.setKelurahan();
                    this.checking(data);
                    
                });                                               
            }            
            this.$validator.localize('en', this.dictionary);       
        },
        
        async save(isUpdate = false) {                
            this.$validator.validateAll();    
            this.formModel.time = moment().valueOf();
            this.formModel.info = null;
            if( !this.errors.any() ) {
                var res = isUpdate ? await model.update(this.formModel): await model.create(this.formModel);                
                if(res.status === 200){   
                    this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
                    this.$router.go(-1);                    
                } else {
                    var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
                    var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
                    if(res.data){ if(res.data.message){ text += ' ' + res.data.message; } else {this.validate(res.data);}}                
                    this.$swal({type: 'error', title: title, text: text});                    
                }
            }             
        },
       
        validate(data){
            data.forEach( (item) => {
                this.$validator.errors.add({field : item.field,msg : item.message});
            });
        },        
                
        checking(data){
            if(data.info){
                if(data.info.action === 'synch' && data.info.data){
                    this.validate(data.info.data);
                }
            }            
        },        
                
        clear () {
            this.formModel = {};
            this.$validator.reset();
        },
    
        customFilter (item, queryText, itemText) {
            const textOne = item.name.toLowerCase()
            //const textTwo = item.abbr.toLowerCase()
            const searchText = queryText.toLowerCase()

            return textOne.indexOf(searchText) > -1; 
        },    
        
        setKelurahan(){
            model.getKelurahan({'KelurahanSearch[id]':this.formModel.kelurahan_id}).then(res =>{
               this.kelurahan = res.data; 
            });
        }

       
    }
}
</script>